import { Spinner, WarningIcon } from 'components/shared/PriceNext';
import { FormattedMessage } from 'react-intl';

const LoadingStatus = ({ hasBackendMessage }: { hasBackendMessage: boolean }) => (
  <div className="d-flex align-items-center gap-2 h-100 px-3 flex-grow-1">
    {Spinner}
    <span className="flex-grow-1">
      <FormattedMessage id="secondary-market-batch-grid.operation.status.loading" />
    </span>
    {hasBackendMessage && WarningIcon}
  </div>
);

export default LoadingStatus;
